{
    "DisplayasoptionsGrid": "Rooster",
    "DisplayasoptionsColumns": "Kolommen",
    "DisplayasoptionsRows": "rijen",
    "DisplayasoptionsChart": "Grafiek",
    "DisplayasoptionsDetailedtableview": "Gedetailleerde tabelweergave",
    "DisplayasoptionsBlfviewhorizontal": "BLF-weergave (horizontaal)",
    "DisplayasoptionsBlfviewvertical": "BLF-weergave (verticaal)",
    "DisplayasoptionsChartview": "Kaartweergave",
    "NAME": "DisplayedAsOptions"
}